export const environment = {
    production:true,
    mapboxToken: 'pk.eyJ1IjoiZWJjYWJyZXJhMDgiLCJhIjoiY2swcXFlY3N2MGJiZTNjbWx4ZmR0cXk1NCJ9.MamOuw-sZvAdrcARBdne5Q',
    urlApiEndPointV3: 'https://managerfarma-ftepf4fteraaemfb.spaincentral-01.azurewebsites.net/'
}